import { useState } from 'react';
import { FerrytimetablePageProps } from '.';
import { useLanguage } from '../../../contexts/language';
import PublicJourneyCard from './PublicJourneyCard';
import { IslandJourneyDirection } from '../types';
import { Tab, Tabs } from '@mui/material';

const JourneyList = ({ journeys, island }: FerrytimetablePageProps) => {
  const { t } = useLanguage();
  const [selectedDirection, setSelectedDirection] =
    useState<IslandJourneyDirection>('outbound');

  return (
    <div className="h-full grid grid-cols-[repeat(2,1fr)] grid-rows-[min-content_1fr] gap-4">
      <div className="hidden col-span-2 md:grid grid-cols-subgrid">
        <h2 className="text-lg font-medium uppercase">
          {t('content.outbound')}
        </h2>
        <h2 className="text-lg font-medium uppercase">
          {t('content.inbound')}
        </h2>
      </div>
      <div className="block md:hidden col-span-2">
        <Tabs
          onChange={(_, value) => {
            setSelectedDirection(value as IslandJourneyDirection);
          }}
          variant="fullWidth"
          value={selectedDirection}
        >
          <Tab value="outbound" label={t('content.outbound')} />
          <Tab value="inbound" label={t('content.inbound')} />
        </Tabs>
      </div>
      <div
        className={`col-span-2 md:col-span-1 flex flex-col gap-3 ${selectedDirection === 'outbound' ? '' : 'hidden md:flex'}`}
      >
        {journeys
          .filter(journey => island.id === journey.departureIslandId)
          .map((journey, idx) => (
            <PublicJourneyCard
              publicJourney={journey}
              islandId={island.id}
              direction="outbound"
              key={idx}
            />
          ))}
      </div>
      <div
        className={`col-span-2 md:col-span-1 flex flex-col gap-3 ${selectedDirection === 'inbound' ? '' : 'hidden md:flex'}`}
      >
        {journeys
          .filter(journey => island.id === journey.arrivalIslandId)
          .map((journey, idx) => (
            <PublicJourneyCard
              publicJourney={journey}
              islandId={island.id}
              direction="inbound"
              key={idx}
            />
          ))}
      </div>
    </div>
  );
};

export default JourneyList;
